class NewslettersStateService {
    items: any[];
    orderByOptions: string[];
    sortOrderOptions: string[];
    isSearchVisible: boolean;
    searchText: string;
    orderBy: string;
    sortOrder: string;
    paging: any;
    oneOffNLEnabled: boolean;
    loadPagePromise: any;
    filteredItems: any[];
    permissions: any;

    constructor(
        private $q,
        private $translate,
        private OutputNewsletterService,
        private OutputMgrService,
        private CoreUserService,
        private EntitlementService
    ) {
        'ngInject';
        this.oneOffNLEnabled = false;
        this.items = [];
        this.filteredItems = [];
        this.orderByOptions = [
            'name',
            'type',
            'distributionCount',
            'recipientListName',
            'createdByName',
        ];
        this.sortOrderOptions = [
            'ascending',
            'descending'
        ];
        this.isSearchVisible = false;
        this.permissions = false;
        this.searchText = '';
        this.orderBy = 'name';
        this.sortOrder = 'ASC';
        this.paging = {
            itemsPerPage: 25,
            selectedPage: 1,
            totalItems: 0
        };
    }

    /**
     * Gets an array of dashboard objects based on the parameters specified.
     * @param {object} params the key / value pairs for the get request
     *          {
     *              _orderby: "ASC" || "DESC",
     *              _sort: "field to sort by",
     *              q: "search text if any"
     *          }
     * @returns promise
     */
    getNewsletters(params) {
        this.OutputNewsletterService.getNewsletterByCompanyId().then((items)=>{
            this.items = items;
        });
    }

    getNewsletterPermissions(){
        return this.CoreUserService.hasPermissions();
    }

    /**
     * Deletes a newsletter and related distributions
     * @param newsletterId
     */
    deleteNewsletter(newsletterId) {
        var deferred = this.$q.defer();
        this.OutputMgrService.deleteOutput({type:'Newsletter',_id:newsletterId})
            .then(() => {
                this.load();
                deferred.resolve();
            }, (error) => {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    togglePauseAutomatedNewsletter(newsletter){
        var deferred = this.$q.defer();

        this.OutputNewsletterService.togglePauseAutomatedNewsletter(newsletter)
            .then((item)=>{
                deferred.resolve(item);
            })
            .catch((error)=>{
                deferred.reject(error);
            });
        return deferred.promise;
    }

    /**
     * loads a designated page of dashboard data
     */
    load() {
        return this.loadPagePromise = this.OutputNewsletterService.getNewsletterByCompanyId()
            .then((items) => {
                this.items = items;
                this.filteredItems = items;
                this.updateFilteredItemsType();
                // Handle Successful Response
                this.updatePaging();
                return this.EntitlementService.getCompanyEntitlement('one-off-newsletter')
            })
            .then(response =>{
               this.oneOffNLEnabled =  response['one-off-newsletter'] && response['one-off-newsletter'].value ? response['one-off-newsletter'].value : false;
            })
    }

    /**
     *
     * @param searchText
     * @return {any}
     */
    filterNewsletters(searchText) {
        let items = this.items;
        if(searchText && items) {
            this.filteredItems = items.filter((item) => {
                return (item.name && item.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                    || (item.type && item.type.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                    || (item.recipientListName && item.recipientListName.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                    || (item.createdByName && item.createdByName.toLowerCase().indexOf(searchText.toLowerCase()) != -1);
            })
        } else {
            this.filteredItems = items;
        }
        this.updatePaging();
    }

    /**
     * Updates the paging data to match the current filtered item set
     */
    updatePaging(){
        this.paging.selectedPage = 1;
        this.paging.totalItems = this.filteredItems.length;
    }

    /**
     * Returns boolean value indicating whether or not newsletter is recurring
     * @param newsletter
     * @returns {any}
     */
    isRecurringNewsletter(newsletter) {
        return newsletter && newsletter.settings && newsletter.settings.recurring;
    }

    /**
     * Updates the type property on a collection of newsletters
     */
    updateFilteredItemsType() {
        this.filteredItems.forEach((newsletter, index) => {
            this.filteredItems[index] = this.updateNewsletterType(newsletter);
        });
    }

    /**
     * Updates type of individual newsletter
     * @param newsletter
     * @returns {any}
     */
    updateNewsletterType(newsletter) {
        // Recurring Paused
        if (newsletter.settings && newsletter.settings.recurring && newsletter.settings.paused) {
            newsletter.type =  this.$translate.instant('newsletter__automated-status') + ' - ' + this.$translate.instant('newsletter__automation-paused-status');
        // Recurring Unpaused
        } else if (newsletter.settings && newsletter.settings.recurring && !newsletter.settings.paused) {
            newsletter.type = this.$translate.instant('newsletter__automated-status');
        // One off
        } else if (newsletter.settings && newsletter.settings.oneOff) {
            newsletter.type = this.$translate.instant('newsletter__oneoff-status');
        // Manual
        } else if (newsletter.settings && !newsletter.settings.recurring && !newsletter.settings.oneOff) {
            newsletter.type = this.$translate.instant('newsletter__manual-status');
        }
        return newsletter;
    }
}

export default NewslettersStateService;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletters/newsletters-state.service.ts
 **/